import ICrossroadItem from "./ICrossroadItem";

export default class CrossroadItem implements ICrossroadItem {
    constructor(
        public imgSrc: string,
        public imgSrcSet: string,
        public title: string,
        public content: string,
        public link: string | undefined = undefined,
        public linkLabel: string | undefined = undefined
    ) {}
}
